var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12L10.5 14V10L14 12Z",
    fill: "#020617",
    stroke: "#020617",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.7076V11.2925C2 8.39718 2 6.94951 2.90549 6.01804C3.81099 5.08657 5.23656 5.04625 8.08769 4.96561C9.43873 4.9274 10.8188 4.90002 12 4.90002C13.1812 4.90002 14.5613 4.9274 15.9123 4.96561C18.7634 5.04625 20.189 5.08657 21.0945 6.01804C22 6.94951 22 8.39717 22 11.2925V12.7076C22 15.6029 22 17.0506 21.0945 17.982C20.189 18.9135 18.7635 18.9538 15.9124 19.0345C14.5613 19.0727 13.1812 19.1001 12 19.1001C10.8188 19.1001 9.43867 19.0727 8.0876 19.0345C5.23651 18.9538 3.81097 18.9135 2.90548 17.982C2 17.0506 2 15.6029 2 12.7076Z",
    stroke: "#020617",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.0fb167c34190081f4c143ede2e2c07ad.svg";
export { ForwardRef as ReactComponent };